import uuidv4 from 'uuid/v4';

import { dispatchPromise, fetchResources } from './action-helpers';

import { getCurrentUserId } from '../services/store-service';

// TODO: Update default doc props
const DEFAULT_DOC_PROPS = {
    id: null,
    project: null,
    type: 'nifty',
    subtype: undefined,
    name: 'Untitled',
    content: '',
    members: [],
    author: null,
    created_at: null
}

export const createDoc = (docProps = {}) => {
    return dispatchPromise({
        type: 'DOC_CREATE_REQUESTED',
        payload: {
            doc: Object.assign({}, DEFAULT_DOC_PROPS, docProps, {
                id: uuidv4(),
                members: [
                    {
                        id: getCurrentUserId(),
                        permission: 'edit',
                        last_viewed: new Date().getTime(),
                        last_edited: new Date().getTime()
                    }
                ],
                author: getCurrentUserId(),
                created_at: new Date()
            })
        }
    });
}

export const fetchDocs = (projectId, all) => fetchResources('DOCS_FETCH_REQUESTED', { projectId }, all);

export const fetchDoc = (docId, fromToken) => {
    return dispatchPromise({
        type: 'DOC_FETCH_REQUESTED',
        payload: {
            docId,
            fromToken
        }
    });
}

export const updateDoc = (docId, docProps, preventSave) => {
    return dispatchPromise({
        type: 'DOC_UPDATE_REQUESTED',
        preventSave,
        payload: {
            docId,
            docProps
        }
    });
}

export const addDocMembers = (docId, members) => {
    return dispatchPromise({
        type: 'DOC_ADD_MEMBERS_REQUESTED',
        payload: {
            docId,
            members: members.map(({ id, permission }) => ({
                id,
                permission,
                last_viewed: undefined,
                last_edited: undefined
            }))
        }
    });
}

export const removeDocMembers = (docId, members) => {
    return dispatchPromise({
        type: 'DOC_REMOVE_MEMBERS_REQUESTED',
        payload: {
            docId,
            members
        }
    });
}

export const getDocShareLink = docId => {
    return dispatchPromise({
        type: 'GET_DOC_SHARE_LINK',
        payload: { docId }
    });
}

export const docUserEdit = docId => {
    return dispatchPromise({
        type: 'DOC_USER_EDIT_REQUESTED',
        payload: {
            docId,
            userId: getCurrentUserId(),
            last_edited: new Date().getTime()
        }
    });
}
